import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const UpdatesTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  height: 100%;
  overflow: hidden;
`
export const Header = styled.div`
  ${typography.up1.regularSerif}
`

export const Subheader = styled.div`
  ${typography.baseline.regularSans}
`

export const HeaderAndButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
  color: #003f7e !important;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  button {
    border: 1px solid #003f7d;
  }

  .birdsong-button {
    border-radius: 20px;
    padding: 6px 16px;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 85%;
`

export const DialogAnchor = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
`

export const UpdatesGrid = styled.div`
  display: flex;
  width: 100%;
  overflow-y: auto;
  max-height: 430px;
  padding-right: 8px;
  gap: 16px;
  align-items: flex-start;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: calc(33.333% - 11px);

  @media (max-width: 1200px) {
    width: calc(50% - 8px);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const UpdatesTable = styled.div`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-bottom: 16px;
  grid-column: 1 / -1;
`

export const DividerContainer = styled.div`
  padding: 0 16px;
`

export const SortButton = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 4px;
  color: #003f7e;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`

export const FilterButton = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 4px;
  color: #003f7e;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`
